// Custom node component for knowledge graph - 35 lines ✅
import { Handle, Position, NodeProps } from 'reactflow'
import { FileText, AlertCircle, CheckCircle } from 'lucide-react'

export function KGNodeComponent({ data }: NodeProps) {
  const { label, entityType } = data

  // Icon based on entity type
  const iconMap: Record<string, typeof FileText> = {
    issue: AlertCircle,
    knowledge_entry: FileText,
    resolution_method: CheckCircle,
  }
  const Icon = iconMap[entityType as string] || FileText

  return (
    <div className="flex min-w-[150px] items-center gap-2 px-3 py-2">
      <Handle type="target" position={Position.Top} className="!bg-kaycoo-teal-dark" />
      <Icon className="h-4 w-4 flex-shrink-0" />
      <div className="flex-1 truncate text-xs" title={label}>
        {label}
      </div>
      <Handle type="source" position={Position.Bottom} className="!bg-kaycoo-teal-dark" />
    </div>
  )
}
